export const CLASS_NAME = 'cst-content-wrapper'
